var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
var ConfigurationRepository_1;
import { IAPIHTTPDataSourceType } from '../../DataSource/APIHTTPDataSource/IAPIHTTPDataSource';
import { ICacheDataSourceType } from '../../DataSource/CacheDataSource/ICacheDataSource';
import { StateMap } from '../../../Domain/DTOs/Module/ModuleDTO';
import { IEventsDataSourceType } from '../../DataSource/EventsDataSource/IEventsDataSource';
import { ILegacyAPIHTTPDataSourceType } from '../../DataSource/LegacyAPIHTTPDataSource/ILegacyAPIHTTPDataSource';
import { IApplicationRepositoryType } from '../../../Domain/UseCases/Application/IApplicationRepository';
import { IStorageDataSourceType } from '../../DataSource/StorageDataSource/IStorageDataSource';
import { Observable } from '../../Observable/Observable';
import { merge } from '../../../Helpers';
import { hexToRgb } from '../../../Helpers/Hex/Hex';
import { injectable } from '../../Decorators/Injectable';
import { inject } from '../../Decorators/Inject';
import { CoreConfig } from '../../../CoreConfig';
import { Platform } from 'react-native';
let ConfigurationRepository = ConfigurationRepository_1 = class ConfigurationRepository {
    constructor(dataSource, legacyDataSource, cache, eventsDataSource, applicationRepository, storageDataSource) {
        this.dataSource = dataSource;
        this.legacyDataSource = legacyDataSource;
        this.cache = cache;
        this.eventsDataSource = eventsDataSource;
        this.applicationRepository = applicationRepository;
        this.storageDataSource = storageDataSource;
        this.countryCode = new Observable('');
        this.configuration = new Observable({});
        this.isLoadedConfiguration = new Observable(false);
        this.shareOptions = new Observable([]);
        this.configuration.observe(this, value => {
            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1;
            this.countryCode.next((_b = (_a = value.customer) === null || _a === void 0 ? void 0 : _a.settings) === null || _b === void 0 ? void 0 : _b.country_code);
            if (Platform.OS === 'web') {
                this.shareOptions.next(((_d = (_c = value.application) === null || _c === void 0 ? void 0 : _c.settings) === null || _d === void 0 ? void 0 : _d.share_options) || [
                    { key: 'email' },
                    { key: 'facebook' },
                    { key: 'whatsapp' },
                    { key: 'twitter' }
                ]);
            }
            this.dataSource.setLocalization(((_f = (_e = value === null || value === void 0 ? void 0 : value.application) === null || _e === void 0 ? void 0 : _e.components) === null || _f === void 0 ? void 0 : _f.api_http_data_source) || {});
            if (value.application && value.application.settings && value.application.settings.api_url) {
                this.dataSource.setServerURL(value.application.settings.api_url);
                this.legacyDataSource.setServerURL(value.application.settings.api_url);
            }
            if (value.application && value.application.settings && value.application.settings.mock) {
                this.dataSource.mock();
                this.legacyDataSource.mock();
            }
            else {
                this.dataSource.unmock();
                this.legacyDataSource.unmock();
            }
            if (value.application && value.application.settings && value.application.settings.application_token) {
                this.dataSource.setApplicationToken(value.application.settings.application_token);
                this.legacyDataSource.setApplicationToken(value.application.settings.application_token);
                this.applicationRepository.setApplicationToken(value.application.settings.application_token);
            }
            if (value.application && value.application.settings && value.application.settings.api_version) {
                this.dataSource.setAPIVersion(value.application.settings.api_version);
                this.legacyDataSource.setAPIVersion(value.application.settings.api_version);
            }
            if (value.application && value.application.settings && value.application.settings.namespace) {
                this.dataSource.setNamespace(value.application.settings.namespace);
                this.legacyDataSource.setNamespace(value.application.settings.namespace);
            }
            this.applicationRepository.setShareLinkConfiguration({
                apiKey: (_j = (_h = (_g = this.configuration.value.application) === null || _g === void 0 ? void 0 : _g.settings) === null || _h === void 0 ? void 0 : _h.firebase) === null || _j === void 0 ? void 0 : _j.api_key,
                shareWebsite: (_m = (_l = (_k = this.configuration.value.application) === null || _k === void 0 ? void 0 : _k.settings) === null || _l === void 0 ? void 0 : _l.firebase) === null || _m === void 0 ? void 0 : _m.share_link,
                website: this.configuration.value.website_url,
                packageName: (_p = (_o = this.configuration.value.application) === null || _o === void 0 ? void 0 : _o.settings) === null || _p === void 0 ? void 0 : _p.package_name,
                googleStoreLink: (_r = (_q = this.configuration.value.application) === null || _q === void 0 ? void 0 : _q.settings) === null || _r === void 0 ? void 0 : _r.google_store_link,
                minAppVersion: (_t = (_s = this.configuration.value.application) === null || _s === void 0 ? void 0 : _s.settings) === null || _t === void 0 ? void 0 : _t.min_app_version,
                bundleID: (_v = (_u = this.configuration.value.application) === null || _u === void 0 ? void 0 : _u.settings) === null || _v === void 0 ? void 0 : _v.bundle_id,
                appStoreLink: (_x = (_w = this.configuration.value.application) === null || _w === void 0 ? void 0 : _w.settings) === null || _x === void 0 ? void 0 : _x.app_store_link,
                appStoreID: (_z = (_y = this.configuration.value.application) === null || _y === void 0 ? void 0 : _y.settings) === null || _z === void 0 ? void 0 : _z.app_store_id
            });
            this.eventsDataSource.setDebug((_1 = (_0 = value === null || value === void 0 ? void 0 : value.application) === null || _0 === void 0 ? void 0 : _0.settings) === null || _1 === void 0 ? void 0 : _1.debug);
        });
    }
    getPreloadImageTimeout() {
        var _a, _b, _c, _d, _e, _f;
        return typeof ((_c = (_b = (_a = this.configuration.value) === null || _a === void 0 ? void 0 : _a.application) === null || _b === void 0 ? void 0 : _b.settings) === null || _c === void 0 ? void 0 : _c.preload_images_timeout) === 'number'
            ? (_f = (_e = (_d = this.configuration.value) === null || _d === void 0 ? void 0 : _d.application) === null || _e === void 0 ? void 0 : _e.settings) === null || _f === void 0 ? void 0 : _f.preload_images_timeout
            : 2;
    }
    getPushNotificationLocalization() {
        var _a, _b, _c, _d, _e, _f;
        return Object.assign(Object.assign({ the_notification_has_been_expired: 'The notification has been expired!', deep_link_is_missing_in_push_notification: 'Deep link is missing in push notification!' }, (_c = (_b = (_a = this.configuration.value) === null || _a === void 0 ? void 0 : _a.customer) === null || _b === void 0 ? void 0 : _b.texts) === null || _c === void 0 ? void 0 : _c.general), (_f = (_e = (_d = this.configuration.value) === null || _d === void 0 ? void 0 : _d.application) === null || _e === void 0 ? void 0 : _e.components) === null || _f === void 0 ? void 0 : _f.push_notification);
    }
    getInstructions() {
        var _a, _b;
        const value = (_b = (_a = this.configuration.value.application) === null || _a === void 0 ? void 0 : _a.settings) === null || _b === void 0 ? void 0 : _b.instructions;
        return Array.isArray(value)
            ? [...value]
            : [];
    }
    setBehavior(behavior) {
        this.dataSource.setBehavior(behavior);
        return this.storageDataSource.set(ConfigurationRepository_1.behaviorKey, { behavior }).then(() => behavior);
    }
    getBehaviorFromStorage() {
        return this.storageDataSource.get(ConfigurationRepository_1.behaviorKey).then(val => (val === null || val === void 0 ? void 0 : val.behavior) || null);
    }
    getNotificationPermissionsAssets() {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        const assets = [];
        const background = (_d = (_c = (_b = (_a = this.configuration.value) === null || _a === void 0 ? void 0 : _a.application) === null || _b === void 0 ? void 0 : _b.assets) === null || _c === void 0 ? void 0 : _c.images) === null || _d === void 0 ? void 0 : _d.notifications_permission_background_url;
        const cover = (_h = (_g = (_f = (_e = this.configuration.value) === null || _e === void 0 ? void 0 : _e.application) === null || _f === void 0 ? void 0 : _f.assets) === null || _g === void 0 ? void 0 : _g.images) === null || _h === void 0 ? void 0 : _h.notifications_permission_url;
        background && assets.push(background);
        cover && assets.push(cover);
        return assets;
    }
    getShareOptions() {
        return this.shareOptions;
    }
    getCountryCode() {
        return this.countryCode;
    }
    getCachedConfiguration() {
        return this.cache.getCache(ConfigurationRepository_1.configurationKey).data.value;
    }
    getDefaultConfiguration() {
        return this.cache.getCache(StateMap.configuration, {}).data;
    }
    setDefaultConfiguration() {
        var _a, _b;
        const configuration = this.getDefaultConfiguration().value;
        this.eventsDataSource.setDebug((_b = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.application) === null || _a === void 0 ? void 0 : _a.settings) === null || _b === void 0 ? void 0 : _b.debug);
        this.convert(configuration);
        this.setConfiguration(configuration);
        return this.configuration;
    }
    setConfiguration(configuration) {
        return this.configuration.next(configuration);
    }
    getImages() {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v;
        return [
            (_d = (_c = (_b = (_a = this.configuration.value) === null || _a === void 0 ? void 0 : _a.application) === null || _b === void 0 ? void 0 : _b.assets) === null || _c === void 0 ? void 0 : _c.images) === null || _d === void 0 ? void 0 : _d.logo_url,
            (_h = (_g = (_f = (_e = this.configuration.value) === null || _e === void 0 ? void 0 : _e.application) === null || _f === void 0 ? void 0 : _f.assets) === null || _g === void 0 ? void 0 : _g.images) === null || _h === void 0 ? void 0 : _h.home_logo_url,
            (_m = (_l = (_k = (_j = this.configuration.value) === null || _j === void 0 ? void 0 : _j.application) === null || _k === void 0 ? void 0 : _k.assets) === null || _l === void 0 ? void 0 : _l.images) === null || _m === void 0 ? void 0 : _m.horizontal_logo_colored_url,
            (_r = (_q = (_p = (_o = this.configuration.value) === null || _o === void 0 ? void 0 : _o.application) === null || _p === void 0 ? void 0 : _p.assets) === null || _q === void 0 ? void 0 : _q.images) === null || _r === void 0 ? void 0 : _r.horizontal_logo_url,
            (_v = (_u = (_t = (_s = this.configuration.value) === null || _s === void 0 ? void 0 : _s.application) === null || _t === void 0 ? void 0 : _t.assets) === null || _u === void 0 ? void 0 : _u.images) === null || _v === void 0 ? void 0 : _v.screen_background_url,
        ].filter(x => !!x);
    }
    getFonts() {
        var _a, _b, _c;
        const fonts = (_c = (_b = (_a = this.configuration.value) === null || _a === void 0 ? void 0 : _a.application) === null || _b === void 0 ? void 0 : _b.theme) === null || _c === void 0 ? void 0 : _c.typefaces;
        if (!Array.isArray(fonts)) {
            return Promise.resolve([]);
        }
        const actualFonts = fonts.filter(x => !!x && typeof x === 'object' && x.name);
        return Promise.resolve(actualFonts);
    }
    loadConfiguration() {
        const params = {
            path: 'configuration',
            params: {
                include_fields: ['translations']
            }
        };
        return this.dataSource.get(params)
            .then(({ data }) => {
            const modules = this.applicationRepository.getModules().value;
            modules.forEach(module => {
                if ((data === null || data === void 0 ? void 0 : data[module]) === null) {
                    data[module] = this.configuration.value[module];
                }
            });
            const configuration = merge(this.getDefaultConfiguration().value, data);
            this.convert(configuration, true);
            this.loadConfigurationFonts(configuration);
            this.update(configuration);
        })
            .then(() => {
            this.cache.updateCache(ConfigurationRepository_1.configurationKey, this.configuration.value);
            this.isLoadedConfiguration.next(true);
            return this.configuration;
        })
            .catch(error => {
            if (this.applicationRepository.isNetworkUnavailable()) {
                return this.configuration;
            }
            this.loadConfigurationFonts(this.configuration.value || {});
            this.eventsDataSource.sendEvent(CoreConfig.moduleName, {
                module: CoreConfig.moduleName,
                event: 'log',
                data: error
            });
            return Promise.reject(error);
        });
    }
    loadConfigurationFonts(configuration) {
        Object.values(configuration).forEach((module) => {
            var _a, _b;
            if ((_a = module === null || module === void 0 ? void 0 : module.theme) === null || _a === void 0 ? void 0 : _a.fonts) {
                let fonts = Object.entries(((_b = module === null || module === void 0 ? void 0 : module.theme) === null || _b === void 0 ? void 0 : _b.fonts) || {}).reduce((acc, [key, value]) => {
                    acc[key] = typeof value === 'string'
                        ? value.toLowerCase()
                        : value;
                    return acc;
                }, {});
                if (Platform.OS === 'web') {
                    if (fonts.primary) {
                        const loadedFonts = this.applicationRepository.getFontFamily(fonts.primary);
                        if (Object.keys(loadedFonts).length > 0) {
                            fonts = Object.assign(Object.assign({}, this.applicationRepository.getFontFamily(fonts.primary)), fonts);
                            module.theme.fonts = fonts;
                        }
                    }
                }
                else {
                    if (fonts.primary) {
                        fonts = Object.assign(Object.assign({}, this.applicationRepository.getFontFamily(fonts.primary)), fonts);
                    }
                    module.theme.fonts = fonts;
                }
            }
        });
        return configuration;
    }
    convert(configuration, isLoaded) {
        Object.values(configuration).forEach((module) => {
            var _a, _b, _c, _d;
            if ((_a = module === null || module === void 0 ? void 0 : module.theme) === null || _a === void 0 ? void 0 : _a.fonts) {
                let fonts = Object.entries(((_b = module === null || module === void 0 ? void 0 : module.theme) === null || _b === void 0 ? void 0 : _b.fonts) || {}).reduce((acc, [key, value]) => {
                    acc[key] = typeof value === 'string'
                        ? value.toLowerCase()
                        : value;
                    return acc;
                }, {});
                if (Platform.OS === 'web') {
                    if (fonts.primary) {
                        const loadedFonts = this.applicationRepository.getFontFamily(fonts.primary);
                        if (Object.keys(loadedFonts).length > 0) {
                            fonts = Object.assign(Object.assign({}, this.applicationRepository.getFontFamily(fonts.primary)), fonts);
                            module.theme.fonts = fonts;
                        }
                    }
                }
                else {
                    if (fonts.primary) {
                        fonts = Object.assign(Object.assign({}, this.applicationRepository.getFontFamily(fonts.primary)), fonts);
                    }
                    module.theme.fonts = fonts;
                }
            }
            ((_c = module === null || module === void 0 ? void 0 : module.theme) === null || _c === void 0 ? void 0 : _c.colors) && Object.entries(module.theme.colors).forEach(([key, value]) => {
                module.theme.colors = Object.assign(Object.assign({}, module.theme.colors), { [key]: typeof value === 'string'
                        ? hexToRgb(value)
                        : value });
            });
            ((_d = module === null || module === void 0 ? void 0 : module.theme) === null || _d === void 0 ? void 0 : _d.layouts) && Object.entries(module.theme.layouts).forEach(([componentName, layout]) => {
                layout && Object.keys(layout).forEach((selector) => {
                    layout[selector] && Object.entries(layout[selector]).forEach(([cssKey, value]) => {
                        var _a, _b, _c, _d, _e, _f;
                        if (cssKey === 'fontFamily' && isLoaded) {
                            layout[selector] = Object.assign({}, layout[selector]);
                            if (!this.applicationRepository.hasFont(value)) {
                                this.eventsDataSource.sendEvent(CoreConfig.moduleName, {
                                    module: CoreConfig.moduleName,
                                    event: 'log',
                                    data: {
                                        error: `Font ${value} is not loaded!`
                                    }
                                });
                                delete layout[selector].fontFamily;
                                if (Platform.OS === 'web') {
                                    layout[selector].fontFamily = (_c = (_b = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.application) === null || _a === void 0 ? void 0 : _a.theme) === null || _b === void 0 ? void 0 : _b.fonts) === null || _c === void 0 ? void 0 : _c.primary;
                                }
                            }
                        }
                        else if (cssKey === 'font') {
                            layout[selector] = Object.assign({}, layout[selector]);
                            if (!isLoaded) {
                                layout[selector].fontFamily = value;
                            }
                            else if (this.applicationRepository.hasFont(value)) {
                                layout[selector].fontFamily = value;
                            }
                            else {
                                this.eventsDataSource.sendEvent(CoreConfig.moduleName, {
                                    module: CoreConfig.moduleName,
                                    event: 'log',
                                    data: {
                                        error: `Font ${value} is not loaded!`
                                    }
                                });
                            }
                            delete layout[selector].font;
                            if (Platform.OS === 'web') {
                                layout[selector].font = (_f = (_e = (_d = configuration === null || configuration === void 0 ? void 0 : configuration.application) === null || _d === void 0 ? void 0 : _d.theme) === null || _e === void 0 ? void 0 : _e.fonts) === null || _f === void 0 ? void 0 : _f.primary;
                            }
                        }
                    });
                });
            });
        });
        return configuration;
    }
    getSettings() {
        var _a, _b;
        return ((_b = (_a = this.configuration.value) === null || _a === void 0 ? void 0 : _a.application) === null || _b === void 0 ? void 0 : _b.settings) || {};
    }
    getSetting(key) {
        var _a, _b, _c;
        return (_c = (_b = (_a = this.configuration.value) === null || _a === void 0 ? void 0 : _a.application) === null || _b === void 0 ? void 0 : _b.settings) === null || _c === void 0 ? void 0 : _c[key];
    }
    getConfiguration() {
        return Promise.resolve(this.configuration);
    }
    update(value) {
        return this.configuration.update(value);
    }
    getNamespace() {
        var _a, _b;
        return (_b = (_a = this.configuration.value.application) === null || _a === void 0 ? void 0 : _a.settings) === null || _b === void 0 ? void 0 : _b.namespace;
    }
    setServerURL(apiUrl) {
        var _a;
        return Promise.resolve(this.update({
            application: Object.assign(Object.assign({}, this.configuration.value.application), { settings: Object.assign(Object.assign({}, (_a = this.configuration.value.application) === null || _a === void 0 ? void 0 : _a.settings), { api_url: apiUrl }) })
        }));
    }
};
ConfigurationRepository.configurationKey = 'remote_configuration';
ConfigurationRepository.behaviorKey = 'api_behavior';
ConfigurationRepository = ConfigurationRepository_1 = __decorate([
    injectable({ type: 'singleton' }),
    __param(0, inject(IAPIHTTPDataSourceType)),
    __param(1, inject(ILegacyAPIHTTPDataSourceType)),
    __param(2, inject(ICacheDataSourceType)),
    __param(3, inject(IEventsDataSourceType)),
    __param(4, inject(IApplicationRepositoryType)),
    __param(5, inject(IStorageDataSourceType)),
    __metadata("design:paramtypes", [Object, Object, Object, Object, Object, Object])
], ConfigurationRepository);
export { ConfigurationRepository };
